import { createSelector } from '@ngrx/store';
import { mesDossiersFeature } from '@features/demande-remboursement/choix-dossier/store/mes-dossiers/mes-dossiers.reducers';
import { DossierFacturable } from '@features/demande-remboursement/choix-dossier/models/dossier-facturable.model';
import { DossiersSelectionne } from '@features/demande-remboursement/choix-dossier/models/dossier-selectionne.model';

export const selectEntitiesInInsertionOrder = createSelector(
    mesDossiersFeature.selectIds,
    mesDossiersFeature.selectEntities,
    (ids, entities) =>
        (ids as string[]).map(id => entities[id]).filter((e): e is DossierFacturable => !!e)
);

export const selectMesDossierStateDossiersSelectionnes = createSelector(mesDossiersFeature.selectMesDossiersState, (state: any) => state.dossiersSelectionnes as DossiersSelectionne[]);
export const selectMesDossierStateDossiersSelectionnesIds = createSelector(selectMesDossierStateDossiersSelectionnes, (dossiers: DossiersSelectionne[]) => dossiers.map(d => d.id));
export const selectMesDossierStateDossiersSelectionnesDispositifCode = createSelector(selectMesDossierStateDossiersSelectionnes, (dossiers: DossiersSelectionne[]) => dossiers[0]?.dispositifCode ?? null);

export const selectMesDossierStateDossiersSelectionnesTotal = createSelector(mesDossiersFeature.selectMesDossiersState, (state: any) => state.dossiersSelectionnes ? state.dossiersSelectionnes.length : 0);